export default "__VITE_ASSET__766c2fd6__"